import { render, staticRenderFns } from "./AVehicleModificationList.vue?vue&type=template&id=e832e67e&scoped=true"
import script from "./AVehicleModificationList.vue?vue&type=script&lang=js"
export * from "./AVehicleModificationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e832e67e",
  null
  
)

export default component.exports